/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { RouteObject } from 'react-router'
import InterventionFormPage from './InterventionFormPage'
import InterventionListPage from './InterventionListPage'

export const interventionRoutes: RouteObject[] = [
  {
    index: true,
    element: <InterventionListPage />
  },
  {
    path: 'create',
    element: <InterventionFormPage />
  },
  {
    path: ':id/*',
    children: [
      {
        path: 'edit',
        element: <InterventionFormPage />
      }
    ]
  }
]
